import types from '../actions/types';

const INITIAL_STATE = {
  dataMarketings: {
    items: [],
    itemsPerPage: 0,
    page: 0,
    totalItems: 0,
    totalPages: 0,
  },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_MARKETING_LIST:
      return {
        ...state,
        dataMarketings: action.payload,
      };
    default:
      return state;
  }
}
